import * as hljs from 'highlight.js';

export default function () {
	return hljs.getLanguage('xml');
}



// WEBPACK FOOTER //
// ./src/languages/vue.js